import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useQuery, useMutation, useQueryClient } from "react-query";
import axios from "axios";
import { useContext } from "react";
import { FiPercent } from "react-icons/fi";
import { AuthContext } from "../../../Context/AuthContext";
import PageHeader from "../../components/PageHeader";
import Spinner from "../../../Spinner/Spinner";

const AdminCommissionPage = () => {
  const { token } = useContext(AuthContext);
  const queryClient = useQueryClient();
  const [ratePercent, setRatePercent] = useState(0);

  const { data, isLoading } = useQuery(
    "commissionSettings",
    async () => {
      const res = await axios.get(`${process.env.REACT_APP_SERVER_URL}/order/admin/commission`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return res.data.settings;
    },
    { enabled: !!token }
  );

  useEffect(() => {
    if (data?.ratePercent != null) setRatePercent(data.ratePercent);
  }, [data]);

  const updateMutation = useMutation(
    async (payload) => {
      const res = await axios.put(`${process.env.REACT_APP_SERVER_URL}/order/admin/commission`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return res.data;
    },
    { onSuccess: () => queryClient.invalidateQueries("commissionSettings") }
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateMutation.mutateAsync({ ratePercent: Number(ratePercent) });
      toast.success("Commission rate updated");
    } catch (err) {
      toast.error(err.response?.data?.message || "Update failed");
    }
  };

  if (isLoading) return <Spinner />;

  return (
    <>
      <PageHeader title="Commission" subtitle="Platform commission deducted from merchant earnings" icon={FiPercent} />
      <form className="dashboard-card" onSubmit={handleSubmit}>
        <label className="dashboard-form-field">
          <span>Global commission rate (%)</span>
          <input
            type="number"
            min="0"
            max="100"
            step="0.1"
            value={ratePercent}
            onChange={(e) => setRatePercent(e.target.value)}
          />
        </label>
        <p className="dashboard-form-hint">
          Per-merchant overrides can be set on the merchant business profile (`commissionRatePercent`).
        </p>
        <button type="submit" className="dashboard-btn dashboard-btn--primary" disabled={updateMutation.isLoading}>
          Save commission
        </button>
      </form>
    </>
  );
};

export default AdminCommissionPage;
